import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, serviceEventTypes } from 'src/types';
import { urlHelper } from '../helpers';

export const lookupEvent = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceEventTypes.EventLookupDataType): AxiosPromise<serviceEventTypes.EventLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.event.lookupEvent), {
    blockSpinner,
  });
};

export const createEvent = (
  form: serviceEventTypes.EventCreateDataType,
): AxiosPromise<serviceEventTypes.EventCreateResultType> => {
  return axios.post(urlsConfig.event.eventCreate, form, { blockErrorHandler: true });
};

export const createEventDatabase = (
  form: serviceEventTypes.CreateDatabaseEventDataType,
): AxiosPromise<serviceEventTypes.EventHomeCreateResultType> => {
  return axios.post(urlsConfig.event.database, form, { blockErrorHandler: true });
};
export const replicateEventDatabase = (
  form: serviceEventTypes.ReplicateEventDataType,
): AxiosPromise<serviceEventTypes.EventHomeCreateResultType> => {
  return axios.post(urlsConfig.event.replicate, form, { blockErrorHandler: true });
};

export const eventEdit = (
  form: serviceEventTypes.EventEditDataType,
): AxiosPromise<serviceEventTypes.EventEditResultType> => {
  return axios.patch(urlsConfig.event.eventEdit, form, { blockErrorHandler: true });
};

export const eventDelete = ({
  id,
}: serviceEventTypes.EventDeleteDataType): AxiosPromise<serviceEventTypes.EventDeleteResultType> => {
  return axios.delete(`${urlsConfig.event.eventDelete}/${id}`, { blockErrorHandler: true });
};

export const eventSelect = (
  form: serviceEventTypes.EventSelectDataType,
): AxiosPromise<serviceEventTypes.EventSelectResultType> => {
  return axios.post(urlsConfig.event.select, form, { blockErrorHandler: true });
};

export const updateForbiddenModule = (form: {
  addModule?: number;
  deleteModule?: number;
  permissions: number[];
}): AxiosPromise<serviceEventTypes.EventResultType[]> => {
  return axios.patch(urlsConfig.event.updateForbiddenModule, form, { blockErrorHandler: true });
};

export const sendJEMMDataToBackend = (formData: FormData): AxiosPromise<boolean> => {
  return axios.post(urlsConfig.event.importJEMMData, formData);
};

export const sendEfesUsersDataToBackend = (formData: FormData): AxiosPromise<boolean> => {
  return axios.post(urlsConfig.event.importEfesUsersData, formData);
};
